<template>
    <vue-nav-bar></vue-nav-bar>

    <div class="pt-4">
        <div class="heroContainer justify-content-between">
            <!-- Company Icon + Title + Apply Button -->
            <section id="hero" class="hero section dark-background">
                <div class="d-flex flex-row align-items-center justify-content-between"
                    style="padding-left: 30px; padding-right: 30px;">

                    <div class="d-flex flex-row align-items-center">
                        <div class="me-3">
                            <img src="../../../../dist/assets/GITS_Logo_BG.png"
                                style="width: auto; height: 80px; border-radius: 15px;">
                        </div>
                        <div class="d-flex flex-column">
                            <p class="mb-0" style="font-size: 16px; color: #E8E9EB;">{{ this.company_name }}</p>
                            <p class="mb-0" style="font-size: 32px; font-weight: bold; color: white;">{{ jobDetails.job
                                }}
                            </p>
                        </div>
                    </div>

                    <div>
                        <button class="apply-btn" @click="checkToken(jobDetails.recId)">{{ $Translate('applyNow')
                        }}</button>
                    </div>
                </div>
            </section>

            <!-- Details Container -->
            <div class="details-container shadow-sm">
                <ul class="nav nav-tabs nav-justified mb-3 pt-1 custom-nav" id="jobDetailsTabs" role="tablist">
                    <!-- Overview Tab -->
                    <li class="nav-item" role="presentation">
                        <button class="nav-link  active" id="overview-tab" data-bs-toggle="tab"
                            data-bs-target="#overview" type="button" role="tab">{{ $Translate('overview') }}</button>
                    </li>

                    <!-- About Tab -->
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="about-tab" data-bs-toggle="tab" data-bs-target="#about"
                            type="button" role="tab">{{ $Translate('aboutTheCompany') }}</button>
                    </li>
                </ul>

                <!-- Overview Tab Content -->
                <div class="tab-content" id="jobDetailsTabsContent">
                    <div class="tab-pane fade show active p-3" id="overview" role="tabpanel">
                        <!-- Job Title -->
                        <div class="d-flex justify-content-center">
                            <p class="me-2 mb-5" style="font-size: 22px;"><strong>{{ $Translate('jobTitle') }}</strong>
                            </p>
                            <p class="mb-0" style="font-size: 22px;">{{ jobDetails.description }}</p>
                        </div>

                        <!-- Job Summary -->
                        <div class="row d-flex justify-content-start">
                            <p class="mb-0" style="text-align: start;"><strong>{{ $Translate('jobSummary') }}</strong>
                            </p>
                            <p style="text-align: justify;" v-html="jobDetails.jobAdds"></p>
                        </div>

                        <!-- Job Additional Details -->
                        <div class="row mt-4 text-center">
                            <div class="col-md-6 col-lg-3 mb-3">
                                <div class="card p-4 shadow-sm border-light">
                                    <i class="fas fa-building fa-2x mb-3" style="color: #FC7F3F;"></i>
                                    <p><strong>{{ $Translate('department') }}</strong></p>
                                    <p class="mb-0">{{ jobDetails.department }}</p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3 mb-3">
                                <div class="card p-4 shadow-sm border-light">
                                    <i class="fas fa-map-marker-alt fa-2x mb-3" style="color: #FC7F3F;"></i>
                                    <p><strong>{{ $Translate('city') }}</strong></p>
                                    <p class="mb-0">{{ jobDetails.city ? jobDetails.city : '-' }}</p>
                                    <!-- {{ jobDetails.city }} -->
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3 mb-3">
                                <div class="card p-4 shadow-sm border-light">
                                    <i class="fas fa-calendar-alt fa-2x mb-3" style="color: #FC7F3F;"></i>
                                    <p><strong>{{ $Translate('startDateLabel') }}</strong></p>
                                    <p class="mb-0">{{ $ConvertToDateFormat(jobDetails.startDate) }}</p>
                                    <!-- startDate -->
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-3 mb-3">
                                <div class="card p-4 shadow-sm border-light">
                                    <i class="fas fa-hourglass-end fa-2x mb-3" style="color: #FC7F3F;"></i>
                                    <p><strong>{{ $Translate('finalDateLabel') }}</strong></p>
                                    <p class="mb-0">{{ $ConvertToDateFormat(jobDetails.finalDate) }}</p>
                                    <!-- finalDate -->
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- About Tab Content -->
                    <div class="tab-pane fade" id="about" role="tabpanel">
                        <!-- About -->
                        <div class="row d-flex justify-content-start">
                            <p class="mb-2" style="text-align: start;"><strong>{{ $Translate('aboutTheCompany')
                            }}</strong></p>
                            <p style="text-align: justify;">{{ $Translate('briefOfCompany') }}</p>
                            <p style="text-align: justify;">{{ $Translate('forMoreDetails') }} <a
                                    href="https://globalits.bh/" target="_blank">{{ $Translate('visitUrl') }}</a></p>
                        </div>

                        <!-- Our Values -->
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="card p-3 mb-3">
                                    <h4 class="mb-3" style="font-size: 18px;"><strong>{{ $Translate('ourValues')
                                    }}</strong></h4>
                                    <ul style="list-style-position: inside;">
                                        <li style="text-align: start;"><strong>{{ $Translate('value1') }}:</strong>{{
                                            $Translate('value1Sentence') }}</li>
                                        <li style="text-align: start;"><strong>{{ $Translate('value2') }}:</strong>{{
                                            $Translate('value2Sentence') }}</li>
                                        <li style="text-align: start;"><strong>{{ $Translate('value3') }}:</strong>{{
                                            $Translate('value3Sentence') }}</li>
                                        <li style="text-align: start;"><strong>{{ $Translate('value4') }}:</strong>{{
                                            $Translate('value4Sentence') }}</li>
                                    </ul>
                                </div>
                            </div>

                            <!-- Why Work With Us? -->
                            <div class="col-md-6">
                                <div class="card p-3 mb-3">
                                    <h4 class="mb-3" style="font-size: 18px;"><strong>{{ $Translate('whyWorkWithUs')
                                    }}</strong></h4>
                                    <ul style="list-style-position: inside;">
                                        <li style="text-align: start;"><strong>{{ $Translate('why1') }}:</strong>{{
                                            $Translate('why1Sentence') }}</li>
                                        <li style="text-align: start;"><strong>{{ $Translate('why2') }}:</strong>{{
                                            $Translate('why2Sentence') }}</li>
                                        <li style="text-align: start;"><strong>{{ $Translate('why3') }}:</strong>{{
                                            $Translate('why3Sentence') }}</li>
                                        <li style="text-align: start;"><strong>{{ $Translate('why4') }}:</strong>{{
                                            $Translate('why4Sentence') }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>

    <!-- Warning Pop-Up (Login) -->
    <div class="modal fade" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="loginModalLabel">{{ $Translate('alert') }}</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body" style="text-align: center;">
                    <h5>{{ $Translate('loginMessageTitle') }}</h5>
                    <img :src="warningGif" alt="Animated GIF" />
                    <p>{{ $Translate('loginWarningMessageBody') }}</p>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" data-bs-dismiss="modal" @click="goTo('/Login')">
                        {{ $Translate('login') }}
                    </button>
                    <button class="btn btn-primary" data-bs-dismiss="modal" @click="goTo('/Registration')">
                        {{ $Translate('register') }}
                    </button>
                </div>

            </div>
        </div>
    </div>

    <!-- Apply Confirmation Modal -->
    <div class="modal fade" id="applyModal" tabindex="-1" aria-labelledby="applyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-delete-modal text-center px-4 py-3 rounded-4">

                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="warning-icon mb-4">
                        <img :src="warningGif" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('applyAlert') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('applyWarningMessageTitle') }}</p>

                    <div class="d-flex justify-content-center gap-3">
                        <button type="button" class="btn btn-light px-4 py-2 rounded-3" data-bs-dismiss="modal">
                            {{ $Translate('cancel') }}
                        </button>
                        <button type="button" class="btn btn-primary px-4 py-2 rounded-3" @click="confirmApply()">
                            {{ $Translate('apply') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Attachment Warning Pop-Up (Apply) -->
    <div class="modal fade" id="attachmentWarningModal" tabindex="-1" aria-labelledby="attachmentWarningModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-delete-modal text-center px-4 py-3 rounded-4">

                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="warning-icon mb-4">
                        <img :src="warningGif" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('attachmentWarningMessageTitle') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('attachmentWarningMessageBody') }}</p>

                    <div class="d-flex justify-content-center gap-3">
                        <button class="btn btn-outline-primary px-4 py-2 rounded-3" data-bs-dismiss="modal">
                            {{ $Translate('cancel') }}
                        </button>
                        <button class="btn btn-primary px-4 py-2 rounded-3" data-bs-dismiss="modal"
                            @click="goToResumeTab()">
                            {{ $Translate('yes') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <vue-footer :project_name="'Applicant Portal.'"></vue-footer>
</template>

<script>
let loginModal = null;
let applyModal = null;
let attachmentWarningModal = null;

import { Modal } from 'bootstrap';
export default {
    name: 'JobDetailsPage',
    data() {
        return {
            jobDetails: [],
            companyId: 'usmf',
            company_name: 'Global ITS',
            token: GetToken(),
            applicantId: GetApplicantId(),

            warningGif: require('../../../assets/animations/warning.gif'),

            jobToApplyRecId: null,

            ApplicantAttachment: [],
        };
    },
    methods: {
        GetJobDetails: async function () {
            try {
                const jobId = this.$route.query.jobId;

                this.jobDetails = await GetJobDetails(this.companyId, jobId);
            } catch (error) {
                console.error("Error fetching Job Details:", error);
            }
        },
        GetApplicantAttachment: async function () {
            try {
                this.ApplicantAttachment = await GetApplicantAttachment(
                    this.companyId,
                    this.applicantId,
                );
            } catch (error) {
                console.error("Validation failed:", error);
            }
        },
        checkToken(recId) {
            if (!GetToken()) {
                loginModal.show();
            } else if (GetToken() && this.ApplicantAttachment.length <= 0) {
                attachmentWarningModal.show();
            } else {
                applyModal.show();
                this.jobToApplyRecId = recId;
            }
        },
        async apply(recId) {
            try {
                const response = await ApplyForJob(this.companyId, this.applicantId, recId);

                if (response && response.status === 200) {
                    toastr.success(this.$Translate('jobAppliedSuccessfully'));

                    this.GetApplicantApplication();
                } else {
                    toastr.error(this.$Translate('errorApplying'));
                }
            } catch (error) {
                console.error("Error applying applicant application:", error);
            }
        },
        GetApplicantApplication: async function () {
            try {
                this.ApplicantApplication = await GetApplicantApplication(
                    this.companyId,
                    this.applicantId,
                );
            } catch (error) {
                console.error("Validation failed:", error);
            }
        },
        async confirmApply() {
            await this.apply(this.jobToApplyRecId);
            this.jobToApplyRecId = null;

            applyModal.hide();
        },
        goToResumeTab() {
            this.$router.push({ path: '/ApplicantProfile', query: { tab: 'resumeTab' } });
        }
    },
    mounted() {
        this.GetJobDetails();

        loginModal = new Modal(document.getElementById("loginModal"), {});
        applyModal = new Modal(document.getElementById("applyModal"), {});
        attachmentWarningModal = new Modal(document.getElementById("attachmentWarningModal"), {});
    },
};
</script>

<style scoped>
/* You can add custom styles for this component here */
.heroContainer {
    position: relative;
    background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('../../../../dist/assets/RegistrationBackground.jpg');
    background-size: cover;
    background-position: center;
    padding-top: 50px;
    overflow: hidden;
    height: 100vh auto;
    margin-top: -23.5px;
}

.details-container {
    position: relative;
    margin: 30px;
    background-color: white;
    margin-top: 70px;
    text-align: center;
    min-height: 300px;
    padding: 10px auto;
    border-radius: 10px;
}

.apply-btn {
    padding: 10px 25px;
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    background-color: #00013A;
    border: 0.8px solid #00013A;
    border-radius: 25px;
    transition: all 0.3s ease-in-out;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    width: auto;
    min-width: 220px;
}

.apply-btn:hover {
    background-color: #FC7F3F;
    border-color: #FC7F3F;
    transform: scale(1.05);
}

.nav {
    border: none;
    border-top: 0;
}

.nav-link {
    border: none;
    box-shadow: none;
}

.nav-link:hover {
    border-color: transparent;
}

.custom-nav .nav-link.active {
    font-weight: bold;
    border-color: #00013A;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 3.5px solid #00013A;
}

.nav-item {
    border-right: 0.8px solid #ccc;
    margin-top: 5px;
}

.nav-item:last-child {
    border-right: none;
}

.tab-content {
    font-size: 18px;
    padding-left: 30px;
    padding-right: 30px;
}
</style>
